function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M26.118,18.875L43.479,2.81c0.608-0.563,0.645-1.512,0.083-2.12c-0.563-0.607-1.512-0.645-2.12-0.082 L23.909,16.832L6.377,0.607C5.769,0.045,4.82,0.082,4.257,0.689C3.695,1.298,3.731,2.247,4.34,2.81l17.361,16.066L4.34,34.941 c-0.608,0.563-0.645,1.512-0.083,2.12c0.296,0.319,0.698,0.481,1.102,0.481c0.364,0,0.73-0.132,1.019-0.399l17.532-16.224 l17.532,16.224c0.289,0.267,0.654,0.399,1.019,0.399c0.403,0,0.806-0.162,1.102-0.481c0.562-0.608,0.526-1.557-0.083-2.12 L26.118,18.875z"
});

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "47.661px",
    height: "37.751px",
    viewBox: "0 0 47.661 37.751",
    enableBackground: "new 0 0 47.661 37.751",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.ce79bdb4.svg";
export { ForwardRef as ReactComponent };